<fieldset class="grid" aria-label="Einstellungen zu Zertifikatsauszug" data-test-id="aufgabe-versand-root">
	<div class="row">
		<div class="column taetigkeit">
			<mat-radio-group aria-label="Bitte Aktion wählen" class="column" [formControl]="bodyControls.taetigkeit">
				<mat-radio-button
					color="primary"
					class="focus-inwards-dark"
					[value]="versandTaetigkeit.SENDEN_AN"
					data-test-id="senden-an-radio-button">
					senden an
				</mat-radio-button>
				<mat-radio-button
					color="primary"
					class="focus-inwards-dark"
					[value]="versandTaetigkeit.AUSHAENDIGEN_AN"
					data-test-id="aushaendigen-an-radio-button">
					aushändigen an
				</mat-radio-button>
			</mat-radio-group>
		</div>
		<schir-int-client-kontakt-kategorie-checkboxes
			class="column"
			[excludeEingetragenerEigentuemer]="excludeEingetragenerEigentuemer()"
			[control]="bodyControls.empfaenger"
			data-test-id="kontakt-kategorie-checkbox-root" />
	</div>
	@if (bodyControls['vorabPerFax']?.enabled ?? false) {
		<div class="row">
			<mat-checkbox
				class="column focus-inwards-dark"
				color="primary"
				[formControl]="bodyControls['vorabPerFax']"
				(change)="toggleFaxEmpfaengerControls($event.checked)"
				data-test-id="vorab-per-fax-checkbox">
				vorab per Fax
			</mat-checkbox>
			@if (bodyControls['faxEmpfaenger']?.enabled ?? false) {
				<schir-int-client-kontakt-kategorie-checkboxes
					class="column"
					[excludeEingetragenerEigentuemer]="excludeEingetragenerEigentuemer()"
					[control]="bodyControls['faxEmpfaenger']"
					data-test-id="kontakt-kategorie-checkboxes-fax-empfaenger" />
			}
		</div>
	}
	<schir-int-client-notiz-in-aufgabe-editor
		class="row note"
		[aufgabenTyp]="AufgabenTyp.ABSCHRIFT_ZERTIFIKATSAUSZUG" />
</fieldset>
